// extracted by mini-css-extract-plugin
export var standaloneTable = "_gt-0";
export var standaloneTableWithBodyFill = "_gt-1";
export var withExtraHeader = "_gt-2";